/* unplugin-vue-components disabled */import { render } from "./AuthItemsAttributeTable.vue?vue&type=template&id=f897f47c&scoped=true&ts=true"
import script from "./AuthItemsAttributeTable.vue?vue&type=script&lang=ts"
export * from "./AuthItemsAttributeTable.vue?vue&type=script&lang=ts"

import "./AuthItemsAttributeTable.vue?vue&type=style&index=0&id=f897f47c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f897f47c"]])

export default __exports__